<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core';
import { ResultsFiltersBottomSheetWrapper, ResultsFiltersDropdownWrapper } from '#components';

const prefix = 'components.results.filters';

const properties = defineProps<{ disabled?: boolean }>();

const durationStore = useDurationFilterStore();
const airportsStore = useAirportsFilterStore();
const searchResultIndexStore = useSearchResultIndexStore();

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMd = breakpoints.greaterOrEqual('md');
</script>

<template>
  <component
    :is="isMd ? ResultsFiltersDropdownWrapper : ResultsFiltersBottomSheetWrapper"
    class="lg:flex-1"
    :trigger-button-label="$t(`${prefix}.duration`)"
    :has-active-filters="durationStore.hasActiveFilters"
    :disabled="properties.disabled"
    :results-count="searchResultIndexStore.availableSearchResults.length"
    v-on="isMd ? {} : { reset: () => durationStore.$reset() }"
  >
    <ResultsFiltersDuration />
  </component>
  <component
    :is="isMd ? ResultsFiltersDropdownWrapper : ResultsFiltersBottomSheetWrapper"
    class="lg:flex-1"
    :trigger-button-label="$t(`${prefix}.airports`)"
    :has-active-filters="airportsStore.hasActiveFilters"
    :disabled="properties.disabled"
    :results-count="searchResultIndexStore.availableSearchResults.length"
    v-on="isMd ? {} : { reset: () => airportsStore.$reset() }"
  >
    <ResultsFiltersAirports />
  </component>
</template>
